export default __webpack_public_path__ + "static/snel_makelaar_1-f2aef8c346390e2fefde138a848af817.svg";